import React, { useEffect, useState } from 'react';
import styles from './business-administrators-card.module.scss';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { DefaultButton, AdministratorMiniCard } from 'shared/ui';
import { SearchInput } from 'shared/ui';
import { observer } from 'mobx-react';
import { businessStore, UserRoleEnum, userStore } from 'entities/index';

interface IBusinessAdministratorsCardProps {
  businessId: string;
}

export const BusinessAdministratorsCard: React.FC<IBusinessAdministratorsCardProps> =
  observer(({ businessId }) => {
    const [inputValue, setInputValue] = useState('');
    const normalizedSearch = inputValue.toLowerCase().trim();
    const matchesSearch = (administrator: { fio?: string }): boolean => {
      if (!normalizedSearch) return true;
      return (
        administrator.fio?.toLowerCase().includes(normalizedSearch) ?? false
      );
    };
    const navigate = useNavigate();

    useEffect(() => {
      businessStore.initAdministratorsWidgetData(businessId);
    }, []);

    const navigateToCreateAdministrator = () => {
      const path = AppLinks.CreateAdministratorLink.replace(':id', businessId);
      navigate(path);
    };

    return (
      <div className={styles.business_administrators__container}>
        <div className={styles.container__search}>
          <SearchInput
            value={inputValue}
            placeholder="Поиск по управляющим"
            onChange={setInputValue}
          />
        </div>
        <div className={styles.container__content}>
          <div className={styles.content}>
            {businessStore.administratorsWidgetData
              ?.filter(matchesSearch)
              .map((administrator, index) => (
                <AdministratorMiniCard
                  administratorInfo={administrator}
                  key={index}
                />
              ))}
          </div>
        </div>
        {userStore.role === UserRoleEnum.OWNER ? (
          <div className={styles.container__button}>
            <div
              className={styles.button__wrapper}
              onClick={navigateToCreateAdministrator}
            >
              <DefaultButton buttonText="Создать управляющего" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  });
